(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-banner-home"] && !Shopify.designMode) return;
  try {
    
const slider = document.getElementById('imageBannerSlider');
const dots   = document.querySelectorAll('.home-bnr-image-banner-dot');
if (slider && dots.length) {
  dots.forEach(dot => dot.addEventListener('click', () => {
    const i = parseInt(dot.dataset.index,10);
    slider.scrollTo({ left: slider.offsetWidth * i, behavior: 'smooth' });
  }));
  slider.addEventListener('scroll', () => {
    const pos = Math.round(slider.scrollLeft / slider.offsetWidth);
    dots.forEach(d => d.classList.remove('active'));
    dots[pos]?.classList.add('active');
  });
}

  } catch(e) { console.error(e); }
})();
})();
